import gql from 'graphql-tag'
import { Fragment } from './fragment'

export const query = gql`
  ${Fragment}
  query fetchLead($id: Int!) {
    records: crm_lead_by_pk(id: $id) {
      ...LeadForm
    }
  }
`

export default query
